module.exports = __webpack_public_path__ + "static/Replica-Bold-1db84bbb81cc1969e00d5fd3c78777f9.woff";